import { createContext, useEffect, useState } from "react";
import axios, { all } from "axios";
import { toast, Toaster } from "sonner";
// import { useNavigate } from "react-router-dom";

export const ApiContext = createContext();

const ApiProvider = ({ children }) => {
  // const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [city, setCity] = useState('');
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [Banner, setBanner] = useState([]);
  const [service, setservice] = useState([]);
  const [PromotionalBanner, setPromotionalBanner] = useState([]);
  const [Booking, setBooking] = useState([]);
  const [review, setreview] = useState([]);
  const [subcategory, setsubcategory] = useState([]);
  const [subservice, setsubservice] = useState([]);
  const [fetchreview, setfetchreview] = useState([]);
  const [createBooking, setcreateBooking] = useState([]);
  const [checkoutSubServiceId, setCheckoutSubServiceId] = useState([]); 
  const [offers, setOffers] = useState([]); 
  const [lastBookingData, setLastBookingData] = useState({}); 

  // console.log(lastBookingData, "lastBookingData");
  const token = localStorage.getItem("token")
  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2N2I3MDhkYTNhZTdkMmUyNTdiNTdlY2QiLCJpYXQiOjE3NDA1NzM3NjAsImV4cCI6MTc0MTE3ODU2MH0.nMBaEm6kgrm9jwuveab8EdmFcHEIDbOU8dqUI_seNzI";
  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2N2I4MTRkZjFjZDVmNTljNjFmNDY2NWMiLCJpYXQiOjE3NDAxMTczMjEsImV4cCI6MTc0MDcyMjEyMX0.6blEJCDJ8gQcftPduo0cbipoZLuaudyEcB4crJgNynM";
 
  // Function to request OTP
  const requestOTP = async (phone) => {
    try {
      setLoading(true);
      const response = await axios.post(
        "https://wavetechservices.in/api/user/auth/send-otp",
        { phone }
      );
      setLoading(false);
      return response.data; // Might contain success message or OTP reference ID
    } catch (error) {
      setLoading(false);
      console.error(
        "OTP request failed:",
        error 
      );
      throw error;
    }
  };

  // Function to verify OTP and log in
  const verifyOTP = async (phone, otp, fcmToken) => {
    try {
      setLoading(true);
      
      const response = await axios.post(
        "https://wavetechservices.in/api/user/auth/verify-otp",
        { phone, otp , fcmToken }
      );
  
      // console.log("Response Data:", response.data);
      // console.log("test login", response.data.user?.email);
      // console.log("Email Undefined Check:", response.data.user?.email === undefined);
  
      if (response.data.user) {
        // setUser(response.data.user);
        localStorage.setItem("user", JSON.stringify(response.data.user));
  
        if (response.data.user.token) {
          localStorage.setItem("token", response.data.user.token);
        }
      }
      setLoading(false);
      return response
  
      // if (!response.data.user?.email) {
      //   console.log("Navigating to Register");
      //   navigate("/register");
      // } else {
      //   console.log("Navigating to Home");
      //   navigate("/");
      // }
  
      
    } catch (error) {
      setLoading(false); 
      toast.error(error.response?.data?.message)
      console.error("OTP verification failed:", error);
      throw error;
       
    }
  };
  
  useEffect(()=>{
    const fetchOffer = async ()=>{
      const res = await axios.get("https://wavetechservices.in/api/user/offers")
      // console.log("Res :" , res.data.data)
      setOffers(res.data.data)
    }
    fetchOffer()
  } , []) 

  // Function to log out
  const logout = () => {
    setUser(null);
    localStorage.removeItem("token");
  };

  const getcategory = async () => {
    const response = await axios.get(
      "https://wavetechservices.in/api/user/categories"
    );
    // console.log(response);
    setCategories(response.data.data);
  };
  useEffect(() => {
    getcategory();
  }, []);

  const getBanner = async () => {
    const response = await axios.get("https://wavetechservices.in/api/user/banners");
    // console.log(response.data.banners, "banner");
    setBanner(response.data.banners);
  };
  useEffect(() => {
    getBanner();
  }, []);

  const getProfile = async () => {  
    if (!token) return 
    try {
      const response = await axios.get(`https://wavetechservices.in/api/user/profile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("response : ", response)
      setUser(response.data.user);
    } catch (error) {
      console.error(
        "Failed to get user profile:",
        error,
        error.response?.data || error.message
      );
    }
  };

  useEffect(() => { 
    getProfile();
  }, []);

  const getallservice = async () => {
    // const token = localStorage.getItem("token");
    // if (!token) return;
    try {
      const response = await axios.get(
        `https://wavetechservices.in/api/user/services`,
        {
          // headers: {
          //   Authorization: `Bearer ${token}`,
          // },
        }
      );
      setservice(response.data.data);
    } catch (error) {
      console.error(
        "Failed to get user profile:",
        error.response?.data || error.message
      );
    }
  };

  useEffect(() => {
    getallservice();
    getProfile();
  }, []);


  const getPromotionalBanner = async () => {
    // if (!token) return 
    const response = await axios.get(
      "https://wavetechservices.in/api/user/banners/promotional"
    );
    // console.log(response.data, "Promotionalbanner");
    setPromotionalBanner(response.data.data);
  };
  useEffect(() => {
    getPromotionalBanner();
  }, []);

  const getBooking = async () => {
    if (!token) return 
    try{
      const response = await axios.get(
        "https://wavetechservices.in/api/user/bookings",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const travelResponse = await axios.get(
        "https://wavetechservices.in/api/user/travelbookings",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Booking : " , travelResponse);
      setBooking(response?.data?.data?.bookings); 
    } catch(err){
      console.error("Error fetching bookings : " , err)
    }
  };
  
  useEffect(() => {
    getBooking();
  }, []);

  // const Addreview = async (data) => {
  //   const response = await axios.post(
  //     `https://wavetechservices.in/api/user/bookings/${id}/review`,
  //     data,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   );
  //   console.log(response.data, "review");
  //   // setBooking(response.data.data.bookings);
  //   // console.log(response.data.data.bookings , "test");
  // }

  const getsubcategory = async () => {
    const response = await axios.get(
      "https://wavetechservices.in/api/user/subcategories"
    );
    console.log(response.data, "subcategory");
    setsubcategory(response.data.data);
  };
  useEffect(() => {
    getsubcategory();
  }, []);

  const getsubservice = async () => {
    const response = await axios.get(
      "https://wavetechservices.in/api/user/subservices"
    );
    // console.log(response.data, "subservice");
    const allSubServices = response.data.data
    // console.log("allSubServices : " , allSubServices)
    const city = sessionStorage.getItem("city")
    if (city){
      console.log("city : " , city)
      const citySubservices = allSubServices.filter((subservice)=> subservice.city.includes(city))
      setsubservice(citySubservices);
      console.log("citySubservices : " , citySubservices)
    } else{
      setsubservice(allSubServices);
    }
  };
  useEffect(() => {
    getsubservice();
  }, []);

  const getfetchreview = async () => {
    const response = await axios.get("https://wavetechservices.in/api/user/reviews", { 
    });
    // console.log(response.data, "fetchreview");
    setfetchreview(response.data); 
  };
  useEffect(() => {
    getfetchreview();
  }, []);



  const bookSubService = async (token, bookingData, setLoading) => {
    if (!token) return 
    try {
      setLoading(true); 
      const response = await axios.post(
        "https://wavetechservices.in/api/user/bookings",
        bookingData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setLoading(false);
      return response.data; 
    } catch (error) {
      setLoading(false);
      console.error(
        "Error booking sub-service:",
        error.response?.data || error.message
      );
      throw error; // rethrow for handling in the component
    }
  };



  return (
    <ApiContext.Provider
      value={{
        user,
        loading,
        requestOTP,
        verifyOTP,
        logout,
        categories,
        Banner,
        getcategory,
        getBanner,
        setBanner,
        service,
        PromotionalBanner,
        Booking, 
        subcategory,
        offers,
        subservice,
        fetchreview,
        setCheckoutSubServiceId,
        checkoutSubServiceId,
        setLastBookingData,
        lastBookingData,
        city, setCity,
        getsubservice,
      }}
    >
      <Toaster/>
      {children}
    </ApiContext.Provider>
  );
};

export default ApiProvider;
